import { AdditionalInfoDto } from '@/apiClient';

export function getMemberDisplayName(props?: AdditionalInfoDto) {
  if (!props) return 'unknown';
  const ident = props.ident ? ` (${props.ident})` : '';
  return `${props.name}${ident}` || 'unknown';
}
